import React from "react";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import { LoadStatusMap } from "@/utils/enum";
import { getGuidFirst8 } from "@/utils/utils";
import useScreenDetector from "@/hooks/useScreenDetector";
import LoadActionsButton from "@/components/LoadActionsButton";
import OriginToDestination from "../../DealerDashboard/components/OriginToDestination/OriginToDesination";

const useTransporterLoadsTableColumns = () => {
  const { isMobile } = useScreenDetector(480);

  return [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      render: (_, record) => <span className="span-click">{getGuidFirst8(record.id)} </span>,
    },
    {
      title: "Created at",
      dataIndex: "creationTime",
      key: "creationTime",
      render: (_, record) => <span className="span-click">{dateStringToStandardFormat(record.creationTime)}</span>,
    },
    {
      title: "Pickup/DropOff Location",
      dataIndex: "pickupDropoffLocation",
      key: "pickupDropoffLocation",
      render: (_, record) => (
        <OriginToDestination
          record={{
            pickUpAddress: record.shipment.pickupAddress.simplifyAddress,
            dropOffAddress: record.shipment.dropOffAddress.simplifyAddress,
          }}
        />
      ),
    },
    {
      title: "Picked up at",
      dataIndex: "pickedUpAt",
      key: "pickedUpAt",
      render: (_, record) => <span className="span-click">{dateStringToStandardFormat(record.pickedUpAt)}</span>,
    },
    {
      title: "Dropped off at",
      dataIndex: "droppedOffAt",
      key: "droppedOffAt",
      render: (_, record) => <span className="span-click">{dateStringToStandardFormat(record.droppedOffAt)}</span>,
    },
    {
      title: "Total Vehicles",
      dataIndex: "totalVehicles",
      key: "totalVehicles",
      render: (_, record) => <span className="span-click">{record.shipment.vehicles.length}</span>,
    },
    {
      title: "Pickup ETA",
      dataIndex: "pickupEta",
      key: "pickupEta",
      render: (_, record) => (
        <span className="span-click">{dateStringToStandardFormat(record.pickupETA) || "Pending"}</span>
      ),
    },
    {
      title: "Drop off ETA",
      dataIndex: "dropoffEta",
      key: "dropoffEta",
      render: (_, record) => (
        <span className="span-click">{dateStringToStandardFormat(record.dropOffETA) || "Pending"}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, record) => <span className="span-click">{LoadStatusMap[record.status]}</span>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => <LoadActionsButton loadId={record.id} loadData={record} hideOptions={["change-driver"]} />,
    },
    {
      title: "",
      dataIndex: "ribbon",
      key: "ribbon",
      render: (_, record) => {
        const { childLoadId, parentLoadId } = record;

        const exchangeId = childLoadId ?? parentLoadId;

        if (!exchangeId) return null;

        return (
          <div
            style={{
              position: "absolute",
              top: "-0.0625rem",
              right: "-0.0625rem",
              padding: `${isMobile ? "0.125rem" : "0.25rem"} 0.625rem`,
              backgroundColor: "#2d6ac4",
              color: "#fff",
              fontSize: isMobile ? "0.625rem" : "0.75rem",
              borderTopRightRadius: "0.625rem",
              borderBottomLeftRadius: "0.25rem",
              whiteSpace: "nowrap",
            }}
            onClick={e => {
              e.stopPropagation();

              window.location.href = `/loads/all/view?loadId=${exchangeId}`;
            }}
          >
            {`Exchange With: ${getGuidFirst8(exchangeId)}`}
          </div>
        );
      },
    },
  ];
};

export default useTransporterLoadsTableColumns;
